import { render, staticRenderFns } from "./DataTableSb.vue?vue&type=template&id=fc3f14aa"
import script from "./DataTableSb.vue?vue&type=script&lang=js"
export * from "./DataTableSb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports